module.exports = __webpack_public_path__ + "static/media/event-03.b2424db7.jpg";